import { actions } from "@/store/debtorAnalyses/actions";

export const debtorAnalyses = {
  actions,
  namespaced: true,
};
